<template>
  <button
    type="button"
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-contrast-primary active:scale-95 active:bg-primary-400 md:hidden dark:bg-primary-700 dark:active:bg-primary-600 print:hidden"
    @click="open = true"
  >
    <FontAwesomeIcon :icon="['fal', 'bars']" size="lg" />
  </button>
  <TransitionRoot :show="open" as="template">
    <Dialog as="div" class="relative z-100 md:hidden" @close="open = false">
      <TransitionChild
        as="template"
        enter="duration-200 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-150 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogPanel
          class="@container/menu fixed inset-0 flex h-dvh flex-col bg-gradient-to-b from-primary to-primary-700 dark:from-primary-900 dark:to-primary-700"
        >
          <div class="flex shrink-0 items-center justify-between px-5 py-3">
            <div class="flex items-center gap-3">
              <CremaLogo class="h-8 w-8 text-primary-300" />
              <span class="text-lg font-bold text-white">{{ appTitle }}</span>
            </div>
            <button
              type="button"
              class="flex h-10 w-10 items-center justify-center rounded-full text-white hover:bg-black/10 active:scale-95"
              @click="open = false"
            >
              <FontAwesomeIcon :icon="['fal', 'times']" size="lg" />
            </button>
          </div>
          <nav class="min-h-0 flex-1 overflow-y-auto px-5 pb-2 text-white">
            <MainMenu expanded />
          </nav>
          <div
            class="shrink-0 border-t px-5 pt-4 pb-[calc(env(safe-area-inset-bottom)+1.5rem)]"
          >
            <InfoUserModalComponent expanded />
          </div>
        </DialogPanel>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import CremaLogo from '@c/layouts/main-layout/CremaLogo.vue'
import MainMenu from '@c/layouts/main-layout/MainMenu.vue'
import InfoUserModalComponent from '@c/layouts/top-bar/InfoUserModalComponent.vue'

export default {
  name: 'TheMobileMenu',
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
    FontAwesomeIcon,
    CremaLogo,
    MainMenu,
    InfoUserModalComponent
  },
  data() {
    return { open: false }
  },
  computed: {
    appTitle() {
      return import.meta.env.VITE_APP_NAME
    }
  },
  watch: {
    '$route.fullPath'() {
      this.open = false
    }
  }
}
</script>
